import { useEffect, useState } from "react";
import { Route } from "react-router-dom";

import { ContractorList } from "@view/admin/ContractorList";
import CreateNewContractor from "@view/admin/CreateNewContractor";
import { HoursUpload } from "@view/admin/HoursUpload";
import { InvoicePage } from "@view/admin/InvoicePage";
import { PayRollPage } from "@view/admin/PayRollPage";
import PayrollReviewRow from "@view/admin/PayRollReviewPage";
import ARInvoiceReviewPage from "@view/admin/ARInvoiceReviewPage";
import { PlantList } from "@view/admin/PlantList";
import { ClientList } from "@view/admin/ClientList";
import { CompanyList } from "@view/admin/CompanyList";
import { FacilityList } from "@view/admin/FacilityList";
import PlantTimesheetReport from "@view/admin/plant_timesheet_report/PlantTimesheetReport";
import { FullRosterDash } from "@view/admin/FullRosterDash";
import { TerritoryManagerDash } from "@view/admin/TerritoryManagerDash";
import { DashBoardLanding } from "@view/admin/DashboardLanding";
import { useAuth } from "@components/context/AuthContext";
import { IRoleDTO } from "@interfaces/IRoleDTO";
import { AdminRegistration } from "@view/admin/registration/AdminRegistration";
import { PolicyView } from "@view/admin/Policies/PolicyView";

import AdminPTOPage from "@view/admin/AdminPTOPage";
import AuditView from "@view/admin/AuditView";
import { BankAccountList } from "@view/admin/BankAccountList";

export default function RBACRoutes() {
  const { hasPermission, getInfo } = useAuth();
  const [roles, setRoles] = useState<IRoleDTO[]>([]);
  useEffect(() => {
    async function fetchInfo() {
      const result = await getInfo();
      if (result.roles === undefined || result.userType === undefined) {
        // navigate("/landing")
        return;
      }
      setRoles(result.roles);
      // to do
    }
    fetchInfo();
  }, [getInfo]);
  return (
    <>
      {/* Public Routes */}
      {hasPermission(roles, "Landing", "Access") && (
        <Route path="/sadmin/landing" element={<DashBoardLanding />} />
      )}
      {hasPermission(roles, "Plant Timesheets", "Access") && (
        <Route
          path="/admin/plant-timesheets"
          element={<PlantTimesheetReport />}
        />
      )}
      {hasPermission(roles, "Territory Reports", "Access") && (
        <Route
          path="/mgmt/territory-reports"
          element={<TerritoryManagerDash />}
        />
      )}
      {hasPermission(roles, "Roster", "Access") && (
        <Route path="/roster" element={<ContractorList />} />
      )}
      {hasPermission(roles, "Add User Picture", "Access") && (
        <Route path="/usersprofile" element={<FullRosterDash />} />
      )}
      {hasPermission(roles, "Plant List", "Access") && (
        <Route path="/plant-list" element={<PlantList />} />
      )}
      {hasPermission(roles, "Client List", "Access") && (
        <Route path="/client-list" element={<ClientList />} />
      )}
      {hasPermission(roles, "Company List", "Access") && (
        <Route path="/company-list" element={<CompanyList />} />
      )}
      {hasPermission(roles, "Facility List", "Access") && (
        <Route path="/facility-list" element={<FacilityList />} />
      )}
      {hasPermission(roles, "Bank Account List", "Access") && (
        <Route path="/bank-accounts" element={<BankAccountList />} />
      )}
      {hasPermission(roles, "Contractor Create", "Access") && (
        <Route path="/contractor/create" element={<CreateNewContractor />} />
      )}
      {hasPermission(roles, "Invoice", "Access") && (
        <Route path="/invoice" element={<InvoicePage />} />
      )}
      {hasPermission(roles, "Payroll", "Access") && (
        <Route path="/payroll" element={<PayRollPage />} />
      )}
      {hasPermission(roles, "Hours Upload", "Access") && (
        <Route path="/hours-upload" element={<HoursUpload />} />
      )}
      {hasPermission(roles, "Admin Registration", "Access") && (
        <Route path="/admin-registration" element={<AdminRegistration />} />
      )}
      {hasPermission(roles, "Policy Management", "Access") && (
        <Route path="/admin/policies" element={<PolicyView />} />
      )}
      {hasPermission(roles, "PTO Admin", "Access") && (
        <Route path="/admin/pto" element={<AdminPTOPage />} />
      )}
      {hasPermission(roles, "Audit", "Access") && (
        <Route path="/admin/audit" element={<AuditView />} />
      )}
      {hasPermission(roles, "Payroll Review", "Access") && (
        <Route path="/admin/payroll-review" element={<PayrollReviewRow />} />
      )}
      {hasPermission(roles, "Invoice", "Access") && (
        <Route
          path="/admin/ar-invoice-review"
          element={<ARInvoiceReviewPage />}
        />
      )}
    </>
  );
}
